
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';

//```import constants types
import {
    VIDFLEET_CAMERA_LOGS_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';

import {
    cameraLogsResult
} from 'Redux/actions';


function* cameraLogs({ payload }) {
    try {
        const { filters } = payload;
        let count = +filters.limit;
        let from = +filters.from;
        let hasMore = filters.hasMore;

        let QUERY_CAMERA_LOGS = `
            query getLogStatus($esn: String, $from: Int!, $count: Int!){
                result: getLogStatus(esn: $esn, from: $from, count: $count)
            }
        `

        let data = yield call(
            clientQuery,
            QUERY_CAMERA_LOGS,
            {
                esn: filters.esn || null,
                from: from,
                count: count,
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            let result = JSON.parse(data.result)
            yield put(cameraLogsResult({ result, error: null, hasMore }));
        } else {
            yield put(cameraLogsResult({ result: {logs:[]}, error: null, hasMore }));
        }

    } catch (exc) {
        yield put(cameraLogsResult({ error: true, errorCode: exc.request?.status }));
        ExceptionManager(
            exc,
            "Modules/vidFleet/.components/cameraLogs/redux/saga",
            "cameraLogsList"
        )
    }
}

function* watchMethods() {
    yield takeEvery(VIDFLEET_CAMERA_LOGS_REQUEST, cameraLogs);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}